// extracted by mini-css-extract-plugin
module.exports = {"input":"InputForm_input__ptAuj","textarea":"InputForm_textarea__qdWmC","error":"InputForm_error__uQdae"};